module.exports = __webpack_public_path__ + "static/media/icon-circle-headset-blue.8fac7415.svg";